<script setup lang="ts">
import { useCoursesStore } from '~~/stores/courses'
defineOptions({
  name: 'KategoriDetail'
})
const route = useRoute()
const coursesStore: Record<string, any> = useCoursesStore()
const courseList = computed(() => coursesStore.state?.courseList)
const category = computed(() => {
  return courseList?.value?.isLoading
    ? ''
    : courseList?.value?.data?.[0]?.category
})
const title = computed(
  () =>
    `Kategori ${category.value} - Kursus online Terbaru dan Inspiratif | Kognisi.id`
)
const keywords = computed(
  () =>
    `${category.value}, kursus ${category.value},kategori kursus, Agrifood Best Seller, inspirasi, Leadership, Human Resources, Self Development, kognisi, pengetahuan, edukasi, generasi muda`
)
const description = computed(
  () =>
    `Temukan kursus online terbaru, edukatif, dan inspiratif tentang ${category.value} di Kognisi.id . Kami menghadirkan konten relevan yang mendukung pengetahuan generasi muda Indonesia.`
)

useJsonld(() => ({
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  url: `https://kognisi.id/kategori/${route.params.serial}`,
  name: title.value,
  description: description.value,
  inLanguage: 'id',
  mainEntity: {
    '@type': 'ItemList',
    name: `Kursus di Kategori ${category.value}`,
    itemListElement: courseList?.value?.data?.map((course, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: `https://kognisi.id/kursus/${course.urlSlug}`,
      name: course.title
    }))
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Beranda',
        item: 'https://kognisi.id'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Kategori',
        item: 'https://kognisi.id/kategori'
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: category.value,
        item: `https://kognisi.id/kategori/${route.params.serial}`
      }
    ]
  },
  publisher: {
    '@type': 'Organization',
    name: 'Kognisi',
    url: 'https://kognisi.id',
    logo: {
      '@type': 'ImageObject',
      url: 'https://kognisi.id/images/logo-kognisi-kompas.svg',
      width: {
        '@type': 'QuantitativeValue',
        value: 200
      },
      height: {
        '@type': 'QuantitativeValue',
        value: 50
      }
    },
    sameAs: [
      'https://www.tiktok.com/@kognisi.id',
      'https://www.instagram.com/kognisikg',
      'https://youtube.com/@KognisiKG'
    ]
  }
}))
useSeoMeta({
  title: () => title.value,
  description: () => description.value,
  keywords: () => keywords.value,
  ogTitle: () => title.value,
  ogDescription: () => description.value,
  ogUrl: () => `https://kognisi.id/kategori/${route.params.serial}`,
  twitterTitle: () => title.value,
  twitterDescription: () => description.value,
  twitterCard: 'summary',
  robots: 'index, folow'
})

useServerSeoMeta({
  title: () => title.value,
  description: () => description.value,
  keywords: () => keywords.value,
  ogTitle: () => title.value,
  ogDescription: () => description.value,
  ogUrl: () => `https://kognisi.id/kategori/${route.params.serial}`,
  twitterTitle: () => title.value,
  twitterDescription: () => description.value,
  twitterCard: 'summary',
  robots: 'index, folow'
})
</script>

<template>
  <Head>
    <link
      rel="canonical"
      :href="`https://kognisi.id/kategori/${route.params.serial}`"
    />
  </Head>
  <NuxtLayout>
    <NuxtLoadingIndicator />
    <main>
      <LazyModulesKategoriOrganismsWrapper />
    </main>
  </NuxtLayout>
</template>

<style lang="scss">
@use './styles.scss';
</style>
